var render = function render(){var _vm=this,_c=_vm._self._c;return _c('defs',[_c('linearGradient',{attrs:{"id":"svg-gradient","x1":"0%","y1":"0%","x2":"0%","y2":"100%"}},[_c('stop',{style:(`stop-color:${_vm.strokeStop}`),attrs:{"offset":"0%"}}),_c('stop',{style:(`stop-color:${_vm.strokeStart}`),attrs:{"offset":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }